<template>
  <div>
    <Head title="Members" />
    <h1 class="mb-8 text-3xl font-bold">Members</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">&nbsp;</th>
            <th class="pb-4 pt-6 px-6">Telegram ID</th>
            <th class="pb-4 pt-6 px-6">First Name</th>
            <th class="pb-4 pt-6 px-6">Last Name</th>
            <th class="pb-4 pt-6 px-6">Username</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(member, index) in members.data" :key="member.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <label class="flex items-center select-none" :for="`active${member.id}`">
                <input :id="`active${member.id}`" @change="update(index)" v-model="member.active" class="ml-2 mr-1" type="checkbox" />
              </label>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" href="#">
                {{ member.telegram_id }}
                <icon v-if="member.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" href="#" tabindex="-1">
                {{ member.first_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" href="#" tabindex="-1">
                {{ member.last_name }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" href="#" tabindex="-1">
                {{ member.username }}
              </Link>
            </td>
          </tr>
          <tr v-if="members.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">No members found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="members.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    members: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      bot: window.location.pathname.split("/").slice(-1)[0],
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/members/${this.bot}`, pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    update(index) {
      let member = this.$inertia.form({
        bot_id: this.bot,
        active: this.members.data[index].active,
      });

      member.put(`/members/${this.bot}/${this.members.data[index].id}`)
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
